import React from 'react';
import { isNil } from 'lodash';
import Anchor from '../../../../components/link/Anchor';

const OpenPreviewProductDetail = (props) => {
  const {
    text,
    productId,
    storeId,
    storeName,
    noticeContent,
    productNoticeId,
    getProductPreviewData,
    disabledActiveValue,
  } = props;

  /**
   * 링크로 연결할 데이터가 없다면
   * '-' 를 반환함
   */
  if (isNil(text) || (isNil(productId) && isNil(storeId))) {
    return '-';
  }

  return (
    <Anchor
      color="primary"
      isUnderLine
      text={text}
      onClick={() => {
        /**
         *  유효한 id를 링크로 사용하도록 한다.
         */
        if (productId) {
          getProductPreviewData({
            productId,
            disabledActiveValue,
          });
        } else if (storeId) {
          getProductPreviewData({
            storeId,
            storeName,
            noticeContent,
            productNoticeId,
            disabledActiveValue,
          });
        }
      }}
    />
  );
};

export default OpenPreviewProductDetail;
